import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/leagues/reports/user_affiliates/filterReports'; // Importing Filter component
import Table from 'views/leagues/reports/user_affiliates/tableReports'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * ReportView class extending JetView to create a report interface.
 */
export default class ReportView extends JetView {
    /**
     * Configures the layout of the ReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };

        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pagination template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };

        const left = {
            Width: 250, // Width of the left column
            responsiveCell: false, // Disable responsive behavior for this cell
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Usuarios'), width: 300 }, // Label for users
                    ],
                },
                Filter, // Filter component for user affiliates
                Table, // Table component for displaying reports
                toolbar, // Include the previously defined toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'wide', // Type of layout
            responsive: true, // Enable responsive layout
            css: 'out', // CSS class for styling
            cols: [left], // Define columns with the left section
        };
    }
}

// FILE DOCUMENTED
